import { all, call, put, takeLatest } from "redux-saga/effects";
import { FOOD_PREORDER_EVENT_REPORT_REQUEST } from "./actionType";
import {
  getFoodPreOrderEventReportSuccess,
  getFoodPreOrderEventReportFail,
} from "./action";
import { foodPreOrderEventReportAPI } from "../../helpers/fakebackend_helper";

function* getFoodPreOrderEventReportSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventReportAPI, payload);
    yield put(getFoodPreOrderEventReportSuccess(response));
  } catch (error) {
    yield put(getFoodPreOrderEventReportFail(error));
  }
}

export function* watchGetFoodPreOrderEventReportSaga() {
  yield takeLatest(
    FOOD_PREORDER_EVENT_REPORT_REQUEST,
    getFoodPreOrderEventReportSaga
  );
}

export default function* FoodPreOrderEventReportSaga() {
  yield all([watchGetFoodPreOrderEventReportSaga()]);
}
